import { EventBus } from 'primevue/utils';

var OverlayEventBus = EventBus();

export default OverlayEventBus;
